import React from 'react';

export const GameRules = () => {
  const rules = [
    {
      icon: 'solar:star-fall-bold',
      title: 'MINIMUM 10 TO SCORE',
      tag: 'PRECISION MODE',
      desc: 'No more small, lucky points. Only scores of 10+ count — making every move deliberate and every point earned.',
      accent: 'bg-yellow-400',
      textAccent: 'text-black',
    },
    {
      icon: 'solar:crown-star-linear',
      title: '10 TO GET IN',
      tag: 'EARN YOUR SPOT',
      desc: "You must earn your way into the game. No bonus points from dominoing or locks until you've scored at least 10.",
      accent: 'bg-white',
      textAccent: 'text-red-600',
    },
    {
      icon: 'solar:graph-up-linear',
      title: 'ALL POINTS ON LOCK',
      tag: 'HIGH STAKES',
      desc: 'When the game locks, the player with the lowest hand takes ALL opponent points. High risk, high reward.',
      accent: 'bg-red-600',
      textAccent: 'text-white',
    },
  ];

  return (
    <section className="relative bg-black text-white py-24 overflow-hidden border-y-8 border-yellow-400">
      <div className="absolute inset-0 bg-halftone opacity-5 pointer-events-none"></div>
      <div className="container mx-auto px-4 relative z-10">

        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-yellow-400 text-black px-6 py-2 font-anton text-sm tracking-widest uppercase transform skew-x-6 mb-4 shadow-[4px_4px_0px_#fff]">
            🔥 CORE GAMEPLAY
          </div>
          <h2 className="font-anton text-6xl md:text-8xl uppercase transform -rotate-1 text-white">
            SMART <span className="bg-yellow-400 text-black px-2">RULE</span> SYSTEM
          </h2>
          <p className="font-marker text-gray-400 text-xl mt-4 transform rotate-1">
            Customize your matches with advanced rule toggles
          </p>
        </div>

        {/* Rule Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {rules.map((rule, i) => (
            <div key={i} className={`group relative transform ${i === 1 ? 'md:mt-8' : ''} ${i === 2 ? 'md:mt-16' : ''}`}>
              <div className="absolute inset-0 bg-black translate-x-2 translate-y-2"></div>
              <div className="relative bg-black border-4 border-black overflow-hidden hover:-translate-y-1 transition-transform duration-300">
                <div className={`${rule.accent} h-3`}></div>
                <div className="p-6">
                  <div className={`inline-block ${rule.accent} ${rule.textAccent} px-3 py-1 font-bold text-xs uppercase tracking-widest transform -skew-x-6 mb-4`}>
                    ⭐ {rule.tag}
                  </div>
                  <div className={`w-14 h-14 ${rule.accent} flex items-center justify-center mb-4`}>
                    <iconify-icon icon={rule.icon} width="32" style={{ color: rule.textAccent === 'text-black' || rule.textAccent === 'text-red-600' ? '#000' : '#fff' }}></iconify-icon>
                  </div>
                  <h3 className="font-anton text-3xl text-white mb-3 transform -skew-x-3">{rule.title}</h3>
                  <p className="font-sans text-gray-300 text-sm leading-relaxed">{rule.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Fair Mechanics Banner */}
        <div className="bg-black text-white p-8 transform -skew-y-1 border-l-8 border-yellow-400">
          <div className="transform skew-y-1 flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <div className="font-anton text-3xl md:text-4xl mb-1">🎲 100% RANDOM BONEYARD DRAWS</div>
              <p className="font-marker text-gray-300 text-lg">No bias. No manipulation. Pure randomness — just like real life.</p>
            </div>
            <div className="flex gap-8 flex-shrink-0">
              <div className="text-center">
                <div className="font-anton text-5xl text-yellow-400">100%</div>
                <div className="font-sans text-xs uppercase tracking-widest text-gray-400">Fair</div>
              </div>
              <div className="text-center">
                <div className="font-anton text-5xl text-white">0%</div>
                <div className="font-sans text-xs uppercase tracking-widest text-gray-400">Bias</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
